
import msj from '../msjGeneral/index.vue'

export default {
  name: "foot",
  data() {
    return {

    };
  },
  components: {
    msj
  },
};



// WEBPACK FOOTER //
// ./src/components/general/foot/foot.js